// Top bar
import { MONO, T } from '../core/theme.js';
import { Pill } from '../ui/widgets.js';
import { Icon } from '../ui/icons.js';

// Page names: the menu (sidebar.js) and the page header both read these, so they always match
export const VIEW_NAMES = {
  dashboard: 'Dashboard',
  budget: 'Budget',
  subbudgets: 'Sub-budgets',
  quotes: 'Quote to budget',
  schedule: 'On-site schedules',
  tenders: 'Tenders',
  invoices: 'Costs',
  deadlines: 'Deadlines',
  pdf: 'Generate PDF',
  approvals: 'Approvals & POs',
  team: 'Team',
  project: 'Project settings',
  crew: 'Crew',
  deliveries: 'Deliveries',
  suppliers: 'Suppliers',
  system: 'System & backup',
  files: 'Files',
  activity: 'Activity & restore',
  settings: 'Settings',
  copy: 'New project from a past event'
};
export function TopBar({
  project,
  sections,
  view
}) {
  const totalItems = sections.flatMap(s => s.items).length;
  const stColor = {
    Active: T.green,
    Complete: T.blue,
    Planning: T.amber
  };
  return React.createElement("div", {
    style: {
      height: 46,
      background: T.white,
      borderBottom: `1px solid ${T.rule}`,
      display: 'flex',
      alignItems: 'center',
      padding: '0 24px',
      justifyContent: 'space-between',
      flexShrink: 0
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 14
    }
  }, React.createElement("span", {
    style: {
      fontSize: 13,
      fontWeight: 600,
      color: T.coal
    }
  }, VIEW_NAMES[view] || view), view !== 'dashboard' && view !== 'settings' && React.createElement(React.Fragment, null, React.createElement("span", {
    style: {
      width: 1,
      height: 14,
      background: T.rule
    }
  }), React.createElement("span", {
    style: {
      fontSize: 12,
      color: T.mist,
      maxWidth: 260,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  }, project?.name), React.createElement(Pill, {
    label: project?.status,
    color: stColor[project?.status],
    bg: stColor[project?.status] + '18'
  }))), React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 18,
      fontSize: 11,
      color: T.mist
    }
  }, view === 'budget' && React.createElement(React.Fragment, null, React.createElement("span", {
    style: {
      ...MONO
    }
  }, totalItems, " items"), React.createElement("span", {
    style: {
      width: 1,
      height: 14,
      background: T.rule
    }
  })), React.createElement("span", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 5
    }
  }, React.createElement(Icon.link, {
    s: 12,
    c: T.mist
  }), React.createElement("span", {
    style: {
      ...MONO,
      fontSize: 10
    }
  }, "Shared"))));
}
